import React, { useEffect } from "react";
import { Subscription } from "../../Entities/Subscription";
import { Plan } from "../../Entities/Plan";
import { Button, Modal, Space, theme, Tag, Typography } from "antd";
import { formatDate } from "../../Utils/generic-functions";
import useUser from "../../Hooks/useUser";
import { useNavigate } from "react-router-dom";

interface RenewPlanProps {
  subscription: Subscription;
  plan: Plan;
}

const RenewPlan: React.FC<RenewPlanProps> = ({ plan, subscription }) => {
  const { user } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!subscription) {
      navigate("/pricing-plans");
    }
  }, [subscription, navigate]);

  const handleUpgradeNow = () => {
    navigate(
      `/pricing`
    );
  };

  const handleRenewNow = () => {
    navigate(
      `/plan-purchase?action=renew`,
    );
  };

  return (
    <Modal
      className="renew-plan-container"
      open={true}
      centered
      closeIcon={null}
      closable={false}
      title={
        <Space wrap align="center">
          <Typography.Title level={4} style={{ margin: 0 }}>
            {plan.name}
          </Typography.Title>
          <Tag color={theme.useToken().token.colorError}>Expired</Tag>
        </Space>
      }
      footer={
        user && user.role === "admin" ? (
          <Space align="center" size={16}>
            {plan.type !== "free" && (
              <Button type="default" onClick={handleRenewNow}>
                RENEW NOW
              </Button>
            )}
            <Button
              type="primary"
              className="upgrade-btn"
              onClick={handleUpgradeNow}
            >
              UPGRADE NOW
            </Button>
          </Space>
        ) : (
          <Typography.Text>
            Please contact your organization admin.
          </Typography.Text>
        )
      }
    >
      <Typography.Paragraph>
        Your current subscription with {plan.name} was expired on{" "}
        <Typography.Link>{formatDate(subscription.endDate)}</Typography.Link>.
        Please renew your existing subscription or upgrade plan to continue.
      </Typography.Paragraph>
    </Modal>
  );
};

export default RenewPlan;
